/*
 * Publishes the header and footer group heights as CSS variables so `.main`
 * can fill whatever viewport space is left over (see base.css).
 *
 * The groups are measured in place rather than wrapped: the header section is
 * position: sticky, and a wrapper would become its containing block and stop
 * it sticking past its own height.
 */
(function () {
  var GROUPS = [
    { selector: '.shopify-section-group-header-group', variable: '--header-group-height' },
    { selector: '.shopify-section-group-footer-group', variable: '--footer-group-height' },
  ];

  function measure() {
    GROUPS.forEach(function (group) {
      var total = 0;

      document.querySelectorAll(group.selector).forEach(function (el) {
        var rect = el.getBoundingClientRect();
        // Sticky/fixed sections are lifted out of the flow while scrolled.
        if (getComputedStyle(el).position === 'fixed') return;
        total += rect.height;
      });

      document.documentElement.style.setProperty(group.variable, Math.round(total) + 'px');
    });
  }

  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);

  if (window.ResizeObserver) {
    var observer = new ResizeObserver(measure);
    GROUPS.forEach(function (group) {
      document.querySelectorAll(group.selector).forEach(function (el) {
        observer.observe(el);
      });
    });
  }
})();
